@if (showTooltip) {
  <span>
    <button tdWbButton
            tdWbButtonType="icon"
            [attr.aria-label]="('tdWb.components.accountSelector.overlay.LINK_LABEL' | tdWbTranslate) + ', ' + ('tdWb.components.accountSelector.ACCOUNT' | tdWbTranslate)"
            [tdWbOverlayToggle]="accountSelectorTooltipTemplate"
            tdWbOverlayPosition="end-bottom"
            tdWbOverlaySize="small">
      <td-wb-icon class="td-wb-account-selector-tooltip__icon"
                  iconId="tooltip--small"
                  size="14" />
    </button>
  </span>
}
<ng-template #accountSelectorTooltipTemplate>
  <td-wb-overlay>
    <td-wb-overlay-header>
      <span translate="tdWb.components.accountSelector.overlay.HEADER_LABEL"></span>
    </td-wb-overlay-header>
    <p class="td-wb-p td-wb-body-small"
       [innerHTML]="'tdWb.components.accountSelector.overlay.DESCRIPTION_LABEL' | tdWbTranslate"></p>
    <div>
      <a class="td-wb-link"
         tdWbHref="link_preferences_map">
        <span translate="tdWb.components.accountSelector.overlay.CHANGE_LINK"></span>
        <td-wb-icon iconId="caret-right--small"
                    [inline]="true" />
      </a>
    </div>
  </td-wb-overlay>
</ng-template>
